import Box from '@material-ui/core/Box'
import React from 'react'
import styled from 'styled-components'
import {useLeftyTemplate} from 'Event/template/Lefty'

export default function Image() {
  const template = useLeftyTemplate()
  const {footer} = template

  if (!footer.image) {
    return null
  }

  return (
    <Box mb={4}>
      <StyledImage
        src={footer.image}
        aria-label="footer image"
        width={footer.imageSize}
      />
    </Box>
  )
}

const StyledImage = styled.img<{width: number}>`
  width: ${(props) => props.width}px;
  max-width: 100%;
`
